import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Texture.module.sass';
import Button from '../../../ui_kit/button/Button';
import BackButton from '../back_button/BackButton';
import TEXTURES from '../../constants/textures';
import creamTextureImage from '../../../../images/pages/quiz/textures/cream.jpg';
import liquidTextureImage from '../../../../images/pages/quiz/textures/liquid.jpg';
import gelTextureImage from '../../../../images/pages/quiz/textures/gel.jpg';
import maskTextureImage from '../../../../images/pages/quiz/textures/mask.jpg';
import mistTextureImage from '../../../../images/pages/quiz/textures/mist.jpg';
import oilTextureImage from '../../../../images/pages/quiz/textures/oil.jpg';
import scrubTextureImage from '../../../../images/pages/quiz/textures/scrub.jpg';
import serumTextureImage from '../../../../images/pages/quiz/textures/serum.jpg';
import otherTextureImage from '../../../../images/pages/quiz/textures/other.jpg';
import TextureBlock from './texture_block/TextureBlock';

function Texture(props) {
  const {
    increaseStep, decreaseStep, quiz, step,
  } = props;

  const [texture, setTexture] = useState(quiz.texture);
  const [customTexture, setCustomTexture] = useState(
    Object.values(TEXTURES).includes(texture) ? '' : texture || '',
  );

  const onNextClick = () => {
    increaseStep({ ...quiz, texture });
  };

  const setTextures = (updatedTexture) => {
    setTexture(updatedTexture);
    setCustomTexture(updatedTexture);
  };

  const { color } = quiz;

  return (
    <>
      <BackButton decreaseStep={() => { decreaseStep({ ...quiz, texture }); }} />
      <div className={styles.texture}>
        <div className={styles.content}>
          {step}
          <h1 className={styles.title}>
            Reveal how it should feel.
          </h1>
          <div className={styles.description}>
            Choose a texture
          </div>
          <div className={styles.textures}>
            <div className={styles.row}>
              <TextureBlock
                image={creamTextureImage}
                setTexture={setTexture}
                selectedTexture={texture}
                texture={TEXTURES.CREAM}
                color={color}
              />
              <TextureBlock
                image={liquidTextureImage}
                setTexture={setTexture}
                selectedTexture={texture}
                texture={TEXTURES.LIQUID}
                color={color}
              />
              <TextureBlock
                image={gelTextureImage}
                setTexture={setTexture}
                selectedTexture={texture}
                texture={TEXTURES.GEL}
                color={color}
              />
            </div>
            <div className={styles.row}>
              <TextureBlock
                image={maskTextureImage}
                setTexture={setTexture}
                selectedTexture={texture}
                texture={TEXTURES.MASK}
                color={color}
              />
              <TextureBlock
                image={mistTextureImage}
                setTexture={setTexture}
                selectedTexture={texture}
                texture={TEXTURES.MIST}
                color={color}
              />
              <TextureBlock
                image={oilTextureImage}
                setTexture={setTexture}
                selectedTexture={texture}
                texture={TEXTURES.OIL}
                color={color}
              />
            </div>
            <div className={styles.row}>
              <TextureBlock
                image={scrubTextureImage}
                setTexture={setTexture}
                selectedTexture={texture}
                texture={TEXTURES.SCRUB}
                color={color}
              />
              <TextureBlock
                image={serumTextureImage}
                setTexture={setTexture}
                selectedTexture={texture}
                texture={TEXTURES.SERUM}
                color={color}
              />
              <TextureBlock
                image={otherTextureImage}
                setTexture={setTextures}
                selectedTexture={texture}
                texture={customTexture}
                color={color}
                editable
              />
            </div>
          </div>
          <Button
            className={`${styles.button} custom-transparent-button`}
            onClickHandler={onNextClick}
            disabled={!texture}
            text="NEXT"
            color="transparent-blue"
            size="small"
          />
        </div>
      </div>
    </>
  );
}

Texture.propTypes = {
  increaseStep: PropTypes.func.isRequired,
  decreaseStep: PropTypes.func.isRequired,
  quiz: PropTypes.shape({
    texture: PropTypes.string,
    color: PropTypes.string,
  }).isRequired,
  step: PropTypes.node.isRequired,
};

export default Texture;
